export default __webpack_public_path__ + "static/media/loader.65d32840.gif";